export const plansData = [
  {
    id: 'monthly-basic',
    name: 'BASIC FITNESS',
    badge: 'Standard Pass',
    price: '1,499',
    period: '/month',
    description: 'Perfect for beginners and individuals looking for steady gym workouts with certified on-floor guidance.',
    features: [
      'Full Access to Heavy Strength & Cardio Floor',
      'Certified Coach On-Floor Form Guidance',
      'Free Locker & Changing Room Access',
      'Standard Workout Chart & Routine',
      'Access to any 1 Preferred Unit',
    ],
    highlight: false,
  },
  {
    id: 'quarterly-pro',
    name: 'TRANSFORMATION PRO',
    badge: 'Most Popular Choice',
    price: '3,499',
    period: '/quarter (3 mos)',
    description: 'Our flagship transformation package with multi-unit access, custom diet planning, and progressive strength protocols.',
    features: [
      'Universal Access to all 3 Units (Chettipalayam, Pappampatti, Peedampalli)',
      'Customized Fat Loss & Muscle Hypertrophy Plan',
      'Personalized Macro & Diet Consultation',
      'Monthly Body Composition & Progress Tracking',
      'Free Protein Shake & Hydration Bar Access',
      'Priority Trainer Spotting & Form Correction',
    ],
    highlight: true,
  },
  {
    id: 'annual-elite',
    name: 'ANNUAL ELITE VIP',
    badge: 'Maximum Value',
    price: '9,999',
    period: '/year (12 mos)',
    description: 'All-inclusive VIP membership with unrestricted 365-day access, dedicated coaching sessions, and exclusive gym merchandise.',
    features: [
      '365 Days Unrestricted Access to all 3 Units',
      '1-on-1 Dedicated Coach Sessions Included',
      'Bi-Weekly Diet & Nutrition Plan Adjustments',
      'Complimentary IDOL FITNESS ZONE Kit & T-Shirt',
      'Free Freeze Option (up to 30 days pause)',
      'VIP Guest Passes (2 per month for friends)',
    ],
    highlight: false,
  },
];
